import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import MapMarker from 'components/icons/MapMarker';
import Mail from 'components/icons/Mail';
import CallIcon from 'components/icons/Call';
import Calendar from 'components/icons/Calendar';
import { Button } from 'components/components/atoms';
import useBreakpoint from 'utils/hooks/useBreakpoint';

import cx from 'classnames';
import getMapLink from 'utils/getMapLink';
import { useSpring, animated } from '@react-spring/web';
import { useMeasure } from 'react-use';
import trackingEvents from 'utils/trackingEvents';
import { track } from 'utils/tracking';

import { colors } from 'utils/tailwindColors';
const CardContainer = styled.div`
  margin-top: 0.313rem;
  margin-bottom: 0.25rem;
`;

const Card = styled.div`
  margin-top: 1rem;
  margin-bottom: 2rem;
`;

const AvailableFlag = styled.div`
  border-radius: 0.813rem;
  min-height: 1.625rem;
  width: fit-content;
  min-width: 7.5rem;
`;

const CardTitle = styled.div`
  letter-spacing: -0.029rem;
`;

const CardDescription = styled.div.attrs({
  className:
    'font-graphie text-mattamy-blue text-base leading-relaxed md:leading-5  md:mb-0 flex items-start',
})`
  letter-spacing: 0.007rem;
`;

const ToggleScheduleContainer = styled.div`
  place-self: center;
`;
const Img = styled.img`
  min-height: 4.75rem;
  transition: transform 0.5s ease;
`;

/* const IconContainer = styled.div.attrs({
  className:
    "flex justify-center items-center w-30-mattamy h-30-mattamy bg-action-blue inline mr-2 rounded-full text-white",
})`
  min-width: 1.875rem;
`;*/
const IconContainer = styled.div.attrs({
  className:
    'flex justify-center items-center w-30-mattamy h-30-mattamy text-action-blue inline ml-4 mr-2 rounded-full bg-white',
})`
  min-width: 1.875rem;
`;

const StyledButton = styled(Button)`
  height: 3.125rem;
`;
const getNote = (ssn) => {
  if (ssn && ssn.date) {
    const date = ssn.date.split('-');
    const text = ssn.text;
    if (date && date.length > 2) {
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      const dateNote = new Date(date[0], date[1], date[2]);
      dateNote.setHours(0, 0, 0, 0);
      // console.log({ now, dateNote, date });
      if (dateNote >= now) return text;
    }
  }
  return '';
};
const SaleCenterCommunityCardMobile = (props) => {
  const {
    city,
    state,
    communityName,
    direction,
    emailAddress,
    phone,
    saleCenterHours,
    zipCode,
    cardImage,
    flagText,
    firstCTAText,
    firstCTALink,
    secondCTAText,
    secondCTALink,
    openNow,
    latitude,
    longitude,
    salesCenterNoteVM,
    gmbLink = {},
  } = props;
  const breakpoint = useBreakpoint(
    typeof window !== 'undefined' && window.innerWidth,
  );
  const isTablet = ['md'].includes(breakpoint);

  const imageSrc =
    (cardImage && cardImage.srcMobile) || (cardImage && cardImage.src);

  const defaultHeight = '0px';
  const [contentHeight, setContentHeight] = useState(defaultHeight);
  const [scheduleOpen, toggleScheduleOpen] = useState(false);
  const [scheduleRefHeight, { height }] = useMeasure();
  const getProperHeight = () => {
    if (scheduleOpen) {
      return `${contentHeight}px`;
    }
    return '0px';
  };

  const expand = useSpring({
    height: getProperHeight(),
    pointerEvents: scheduleOpen ? 'all' : 'none',
  });
  const fade = useSpring({
    opacity: scheduleOpen ? 1 : 0,
    delay: scheduleOpen ? 5 : 0,
  });
  useEffect(() => {
    setContentHeight(height);
    window.addEventListener('resize', setContentHeight(height));

    return window.removeEventListener('resize', setContentHeight(height));
  }, [height]);
  const saleCenterHoursFilter =
    saleCenterHours &&
    saleCenterHours.filter(
      (e) => (e.hours && e.hours.length > 10) || e.displayText,
    );
  const renderSchedule = () => (
    <animated.div
      className='flex flex-col items-center justify-start w-full'
      ref={scheduleRefHeight}
      style={fade}
    >
      <>
        {saleCenterHoursFilter &&
          saleCenterHoursFilter.map((h, index) => (
            <div
              tabIndex={0}
              key={index}
              className={cx(
                ' w-full flex flex-row px-2 font-graphie text-mattamy-blue text-sm  ',
                {
                  'mb-4': index === saleCenterHoursFilter.length - 1,
                },
              )}
            >
              <div className='w-4/12   font-bold text-right'>{h.day}</div>
              <div className='w-8/12   ml-4 text-left flex flex-col'>
                {h.hours && h.hours.length > 10 && (
                  <span className='text-left font-graphie whitespace-nowrap'>
                    {h.hours}
                  </span>
                )}
                {h.displayText && h.displayText.length > 3 && (
                  <span className='text-left font-graphie whitespace-nowrap'>
                    {h.displayText}
                  </span>
                )}
              </div>
            </div>
          ))}
      </>
    </animated.div>
  );

  const [contentCardHeight, setContentCardHeight] = useState(defaultHeight);
  const [cardOpen, toggleCardOpen] = useState(false);
  const [cardRefHeight, { height: cardHeight }] = useMeasure();
  const getProperCardHeight = () => {
    if (cardOpen) {
      return `${contentCardHeight}px`;
    }
    return '0px';
  };

  const expandCard = useSpring({
    height: getProperCardHeight(),
    pointerEvents: cardOpen ? 'all' : 'none',
  });
  const fadeCard = useSpring({
    opacity: cardOpen ? 1 : 0,
    delay: cardOpen ? 200 : 0,
  });
  const toggleCardSection = () => {
    toggleCardOpen(!cardOpen);
  };
  useEffect(() => {
    setContentCardHeight(cardHeight);
    window.addEventListener('resize', setContentCardHeight(cardHeight));

    return window.removeEventListener(
      'resize',
      setContentCardHeight(cardHeight),
    );
  }, [cardHeight]);
  const renderCardContent = () => (
    <animated.div
      className='flex flex-col mt-4  w-full'
      ref={cardRefHeight}
      style={fadeCard}
    >
      <div className='flex flex-col w-full'>
        <div className='pt-2 pb-4 lg:pt-0 w-full md:w-1/2 flex flex-col justify-between'>
          {getNote(salesCenterNoteVM) && (
            <span className='text-mattamy-blue leading-7 font-graphie mb-2 text-sm'>
              {getNote(salesCenterNoteVM)}
            </span>
          )}
          <h3 className='text-mattamy-blue leading-7 font-graphie mb-2'>
            {'Get directions'}
          </h3>
          <div className='block lg:pl-5 grid grid-cols-2 gap-4'>
            {direction && (
              <CardDescription className='my-2 flex items-center break-all bg-action-blue text-white rounded py-3 justify-left'>
                <IconContainer aria-hidden='true' className='bg-white'>
                  <MapMarker className='h-4 w-4 text-action-blue' />
                </IconContainer>
                <div className='text-white'>
                  <a
                    // className="font-graphie leading-4 text-mattamy-blue mb-10"
                    href={
                      gmbLink && gmbLink.href
                        ? gmbLink.href
                        : latitude && longitude
                        ? getMapLink(latitude + ',' + longitude)
                        : getMapLink(
                            direction +
                              ' ' +
                              city +
                              ' ' +
                              state +
                              ' ' +
                              zipCode,
                          )
                    }
                    target='_blank'
                    rel='noopener noreferrer'
                    aria-label={
                      'Go to ' +
                      direction +
                      ' ' +
                      city +
                      ' ' +
                      state +
                      ' ' +
                      zipCode +
                      '. Opens in GoogleMaps'
                    }
                  >
                    {'Directions'}
                  </a>
                </div>
              </CardDescription>
            )}
            {emailAddress && (
              <CardDescription className='my-2 flex items-center break-all bg-action-blue text-white rounded py-3 justify-left'>
                <IconContainer aria-hidden='true'>
                  <Mail className='h-4 w-4' />
                </IconContainer>
                <a
                  className='break-all text-white'
                  href={`mailto:${emailAddress}`}
                  aria-label={'Email to ' + emailAddress}
                >
                  {'Email'}
                </a>
              </CardDescription>
            )}
            {phone && (
              <CardDescription className='my-2 flex items-center break-all bg-action-blue text-white rounded py-3 justify-left'>
                <div
                  aria-hidden='true'
                  className='flex justify-center items-center w-30-mattamy h-30-mattamy bg-action-blue inline ml-4 mr-2 rounded-full text-white'
                >
                  <CallIcon className='w-30-mattamy h-30-mattamy ' />
                </div>
                <a
                  className='text-white leading-7 font-graphie'
                  href={`tel:${phone}`}
                  aria-label={'Call to ' + phone}
                >
                  {'Call'}
                </a>
              </CardDescription>
            )}
          </div>
        </div>

        <div className='pt-2 lg:pt-0 w-full md:w-1/2 flex flex-col justify-between'>
          {saleCenterHoursFilter && saleCenterHoursFilter.length > 0 && (
            <>
              <CardDescription>
                <IconContainer>
                  <Calendar className='mt-1 h-4 w-4' />
                </IconContainer>
                <span className='mt-1 justify-center items-center place-self-center mr-2'>
                  {'Hours:'}
                </span>
                <button
                  className='flex justify-center items-center place-self-center'
                  onClick={() => {
                    toggleScheduleOpen(!scheduleOpen);
                  }}
                  aria-label={scheduleOpen ? 'Close Schedule' : 'Show Schedule'}
                  aria-expanded={scheduleOpen}
                >
                  <p className='break-all mt-1'>
                    {openNow ? (
                      <>
                        <span className='text-action-blue font-bold'>
                          {'Open Now - '}
                        </span>
                        <span>{'Closes at ' + getClosedHour()}</span>
                      </>
                    ) : (
                      <span className='text-action-blue font-bold'>
                        {'Closed Now'}
                      </span>
                    )}
                  </p>
                  <ToggleScheduleContainer
                    tabIndex={0}
                    className=' place-self-center'
                    // as="button"
                  >
                    <svg
                      className={cx(
                        'mt-1 md:mt-0 w-6 h-6 text-action-blue md:text-mattamy-blue transform',
                        {
                          'rotate-90': scheduleOpen,
                          '-rotate-90': !scheduleOpen,
                        },
                      )}
                      viewBox='0 0 24 24'
                      fill='none'
                    >
                      <path
                        fill='currentColor'
                        d='M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z'
                      />
                    </svg>
                  </ToggleScheduleContainer>
                </button>
              </CardDescription>
              <CardDescription>
                <div className='w-full  z-20 mt-2'>
                  {scheduleOpen && (
                    <animated.div style={expand}>
                      {renderSchedule()}
                    </animated.div>
                  )}
                </div>
              </CardDescription>
            </>
          )}
          <div
            className={cx('p-4 flex flex-col rounded mt-4', {
              'bg-light-blue ':
                (firstCTAText && firstCTALink) ||
                (secondCTAText && secondCTALink),
            })}
          >
            {((firstCTAText && firstCTALink) ||
              (secondCTAText && secondCTALink)) && (
              <p className='font-trade-gothic-20 text-xl mb-2 text-mattamy-blue text-center'>
                Schedule an appointment
              </p>
            )}
            {firstCTAText && firstCTALink && (
              <StyledButton
                color={'action-blue'}
                variant='filled'
                className='block text-base mb-2 pt-0 pb-0 md:w-full'
                onClick={() => {
                  window.dataLayer.push({ event: 'schedule-appointment' });
                  if (trackEventId) {
                    track({ eventId: trackEventId });
                  }
                  window.Calendly.initPopupWidget({
                    url: firstCTALink,
                  });
                }}
              >
                {firstCTAText}
              </StyledButton>
            )}
            {secondCTAText && secondCTALink && (
              <StyledButton
                color={'action-blue'}
                variant='filled'
                className='block text-base mt-1 pt-0 pb-0 md:w-full'
                onClick={() => {
                  window.dataLayer.push({
                    event: 'schedule-appointment-virtual',
                  });
                  if (trackEventId) {
                    track({ eventId: trackEventId });
                  }
                  window.Calendly.initPopupWidget({
                    url: secondCTALink,
                  });
                }}
              >
                {secondCTAText}
              </StyledButton>
            )}
          </div>
        </div>
      </div>
    </animated.div>
  );

  const trackEventId = trackingEvents.BookAppointment;
  const getClosedHour = () => {
    const weekdays = [
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
      'Sunday',
    ];
    const d = new Date();
    let day = d.getDay();
    const hours =
      saleCenterHours &&
      saleCenterHours.find((h) => h.day.includes(weekdays[day - 1]));
    const chour = hours && hours.hours && hours.hours.split('-');
    return chour && chour.length > 1 ? chour[1] : '';
  };
  return (
    <CardContainer>
      <Card className='w-full bg-mattamy-white flex flex-col lg:flex-row justify-center items-start'>
        <div className='flex flex-row w-full items-start'>
          <div className='text-center relative rounded overflow-hidden w-3/12 h-16'>
            <div className='overflow-hidden rounded'>
              <Img
                src={imageSrc}
                alt={(cardImage && cardImage.alt) || ''}
                className={'bg-gray-300 object-cover w-full'}
              />
            </div>
          </div>

          <div className='h-8 ml-4 text-left w-7/12 flex flex-col'>
            {flagText && (
              <div className='flex flex-row  mb-4 '>
                <AvailableFlag
                  islogo={false}
                  className='flex items-center justify-center bg-white border-mattamy-blue-light border-2 border-mattamy-blue-light hover:md:bg-mattamy-blue-light
                  mt-1 md:mt-0 hover:md:text-white text-mattamy-blue-light px-2'
                >
                  <p className='px-1 text-center font-trade-gothic-20 uppercase text-sm tracking-wide leading-3 mt-1'>
                    {flagText}
                  </p>
                </AvailableFlag>
              </div>
            )}

            <CardTitle className='font-trade-gothic-20 text-mattamy-blue text-2xl leading-8 block'>
              {communityName}
            </CardTitle>
          </div>
          <div className=' h-auto text-left w-2/12 flex flex-col items-center'>
            <button
              className='relative w-10 h-10 lg:w-20 lg:h-20'
              onClick={toggleCardSection}
              aria-label={
                cardOpen
                  ? 'Collapse Information'
                  : 'Expand for more information'
              }
            >
              <div
                className={cx(
                  'absolute top-0 right-0 left-0 bottom-0 m-auto w-8/12 h-1 bg-action-blue rounded transform transition-transform duration-700',
                  { 'rotate-90': !cardOpen },
                )}
              />
              <div className='absolute top-0 right-0 left-0 bottom-0 m-auto w-8/12 h-1 rounded bg-action-blue' />
            </button>
          </div>
        </div>
        <animated.div className='w-full ' style={expandCard}>
          {cardOpen && renderCardContent()}
        </animated.div>
      </Card>
    </CardContainer>
  );
};

SaleCenterCommunityCardMobile.propTypes = {
  props: PropTypes.object,
};

export default SaleCenterCommunityCardMobile;
